/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListIdentityAccess } from "../funcs/accessListIdentityAccess.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListIdentityAccessResult } from "../models/components/listidentityaccessresult.js";
import {
  ListIdentityAccessRequest,
  ListIdentityAccessSecurity,
} from "../models/operations/listidentityaccess.js";
import { unwrapAsync } from "../types/fp.js";
export type IdentityAccessQueryData = ListIdentityAccessResult;

export function prefetchIdentityAccess(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListIdentityAccessRequest,
  security?: ListIdentityAccessSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildIdentityAccessQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildIdentityAccessQuery(
  client$: GramCore,
  request: ListIdentityAccessRequest,
  security?: ListIdentityAccessSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<IdentityAccessQueryData>;
} {
  return {
    queryKey: queryKeyIdentityAccess({
      userId: request.userId,
      gramSession: request.gramSession,
    }),
    queryFn: async function identityAccessQueryFn(
      ctx,
    ): Promise<IdentityAccessQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListIdentityAccess(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyIdentityAccess(
  parameters: { userId: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "access", "listIdentityAccess", parameters];
}
